import { css } from "@emotion/css";
import { useRef } from "react";
import { useButton } from "react-aria";

import { Text, useColors } from "@certn/cascadia-react";

import { LegacyDropdownMenu } from "../../../deprecated/dropdown-menu/LegacyDropdownMenu";
import { LegacyMenuItem } from "../../../deprecated/dropdown-menu/LegacyMenuItem";
import { Icon } from "../../../foundations/icons/Icon/Icon";
import { ActionListItem } from "../../action-list/ActionListItem";
import { useGetAllFocusShadows, useMediaQuery } from "../../utils";

type AccountDropdownProps = {
  title: string;
  children: React.ReactNode;
};

export function AccountDropdown(props: AccountDropdownProps) {
  const colors = useColors();
  const triggerRef = useRef<HTMLButtonElement>(null);
  const { mediaQuery } = useMediaQuery();
  const getAllFocusShadows = useGetAllFocusShadows();
  const { buttonProps } = useButton({ ...props }, triggerRef);

  return (
    <LegacyDropdownMenu
      headerTitle="Dunder Mifflin"
      headerText="dundermifflin.certn.co"
      minWidth="290px"
      triggerRef={triggerRef}
      triggerButton={
        <button
          className={css(
            styles.button,
            css(
              {
                border: `1px solid ${colors["border-base"]}`,
                "&:hover": {
                  backgroundColor: "var(--background-selected-weak-hover)",
                },
                "&:focus-within": getAllFocusShadows(),
              },
              mediaQuery({
                width: ["100%", undefined],
              })
            )
          )}
          {...buttonProps}
          ref={triggerRef}
        >
          <ActionListItem
            title={props.title}
            alignItems="center"
            padding="var(--space-3)"
            trailing={<Icon name="expand_more" />}
          >
            {props.children}
          </ActionListItem>
        </button>
      }
      position="left"
    >
      <LegacyMenuItem icon="person_add" iconColor="icon-weak">
        <Text style="input/text-field">Add user</Text>
      </LegacyMenuItem>
      <LegacyMenuItem icon="add" iconColor="icon-weak">
        <Text style="input/text-field">Add team</Text>
      </LegacyMenuItem>
      <LegacyMenuItem icon="settings" iconColor="icon-weak">
        <Text style="input/text-field">Company settings</Text>
      </LegacyMenuItem>
    </LegacyDropdownMenu>
  );
}

const styles = {
  button: css({
    all: "unset",
    cursor: "pointer",
    display: "flex",
    textAlign: "start",
    boxSizing: "border-box",
    borderRadius: "var(--border-radius-3)",
  }),
};
